<div *ngIf="step === 1">
  <div>Substitute Form W-9</div>
  <h2>Provide taxpayer information for this payout method</h2>
  <p>Hospitable is required to collect tax information to fulfill tax calculations and reporting obligations.</p>
  <div fxLayoutAlign="end center">
    <sbnb-button style="margin-top: 24px" label="Continue" (click)="nextStep()"></sbnb-button>
  </div>
</div>

<div *ngIf="step === 2">
  <div>Substitute Form W-9</div>
  <h2>Is the tax payer an individual or an organization?</h2>
  <mat-radio-group fxLayout="column" fxLayoutGap="8px" [(ngModel)]="type">
    <mat-radio-button fxFlex [value]="'individual'">
      <div>Individual</div>
      <div style="margin-top: 4px; font-size: .875em;">A single person or sole proprietor</div>
    </mat-radio-button>
    <mat-radio-button fxFlex [value]="'organization'">
      <div>Organization</div>
      <div style="margin-top: 4px; font-size: .875em;">A privately held company, public company, non-profit, or governmental organization.</div>
    </mat-radio-button>
  </mat-radio-group>
  <div fxLayoutAlign="end center">
    <sbnb-button style="margin-top: 24px" label="Continue" [disabled]="!canStepForward()" (click)="nextStep()"></sbnb-button>
  </div>
</div>

<div *ngIf="type === 'individual'">
  <div *ngIf="step === 3">
    <div>Substitute Form W-9</div>
    <h2>Who is the taxpayer?</h2>
    <div>
      <div fxLayout="column" class="input">
        <label>First name</label>
        <mat-form-field class="nopadding" fxFlex>
          <input matInput [(ngModel)]="individualFirstName" />
        </mat-form-field>
      </div>
      <div fxLayout="column" class="input">
        <label>Last name</label>
        <mat-form-field class="nopadding" fxFlex>
          <input matInput [(ngModel)]="individualLastName" />
        </mat-form-field>
      </div>
      <div fxLayout="column" class="input">
        <label>Address</label>
        <sbnb-address-autocomplete
          (setAddress)="setIndividualAddress($event)"
          placeholder="Enter an address for the taxpayer identified on this form">
        </sbnb-address-autocomplete>
      </div>
      <div fxLayout="column" class="input">
        <label>E-mail address</label>
        <mat-form-field class="nopadding" fxFlex>
          <input matInput [(ngModel)]="individualEmail" />
        </mat-form-field>
      </div>
    </div>
    <div fxLayoutAlign="end center" fxLayoutGap="16px">
      <sbnb-button type="secondary" label="Back" (click)="previousStep()"></sbnb-button>
      <sbnb-button type="primary" label="Continue" (click)="nextStep()" [disabled]="!canStepForward()"></sbnb-button>
    </div>
  </div>

  <div *ngIf="step === 4">
    <div>Substitute Form W-9</div>
    <h2>What is {{ individualFirstName }} {{ individualLastName }}’s Tax ID Number?</h2>
    <div fxLayout="column" class="input">
      <label>Social Security Number (SSN)</label>
      <mat-form-field class="nopadding" fxFlex>
        <input matInput [(ngModel)]="individualSsn" />
      </mat-form-field>
    </div>
    <div fxLayoutAlign="end center" fxLayoutGap="16px">
      <sbnb-button type="secondary" label="Back" (click)="previousStep()"></sbnb-button>
      <sbnb-button type="primary" label="Continue" (click)="nextStep()" [disabled]="!canStepForward()"></sbnb-button>
    </div>
  </div>
</div>

<div *ngIf="type === 'organization'">
  <div *ngIf="step === 3">
    <div>Substitute Form W-9</div>
    <h2>Who is the taxpayer?</h2>
    <div>
      <div fxLayout="column" class="input">
        <label>Legal name of the organization</label>
        <mat-form-field class="nopadding" fxFlex>
          <input matInput [(ngModel)]="organizationLegalName" />
        </mat-form-field>
      </div>
      <div fxLayout="column" class="input">
        <label>Disregarded entity name (optional)</label>
        <mat-form-field class="nopadding" fxFlex>
          <input matInput [(ngModel)]="organizationDisregardedEntityName" />
        </mat-form-field>
        <div class="hint">Only fill this out if you have a DBA name, trade name or disregarded entity name</div>
      </div>
      <div fxLayout="column" class="input">
        <label>Address</label>
        <sbnb-address-autocomplete
          (setAddress)="setOrganizationAddress($event)"
          placeholder="Enter an address for the taxpayer identified on this form">
        </sbnb-address-autocomplete>
      </div>
    </div>
    <div fxLayoutAlign="end center" fxLayoutGap="16px">
      <sbnb-button type="secondary" label="Back" (click)="previousStep()"></sbnb-button>
      <sbnb-button type="primary" label="Continue" [disabled]="!canStepForward()" (click)="nextStep()"></sbnb-button>
    </div>
  </div>

  <div *ngIf="step === 4">
    <div>Substitute Form W-9</div>
    <h2>What is {{ organizationLegalName }}’s Tax ID number?</h2>
    <div fxLayout="column" class="input">
      <label>Employer Identification Number (EIN)</label>
      <mat-form-field class="nopadding" fxFlex>
        <input matInput [(ngModel)]="organizationEin" />
      </mat-form-field>
    </div>
    <div fxLayoutAlign="end center" fxLayoutGap="16px">
      <sbnb-button type="secondary" label="Back" (click)="previousStep()"></sbnb-button>
      <sbnb-button type="primary" label="Continue" [disabled]="!canStepForward()" (click)="nextStep()"></sbnb-button>
    </div>
  </div>
</div>

<div *ngIf="(type === 'individual' && step === 5) || (type === 'organization' && step === 5)">
  <div>Substitute Form W-9</div>
  <h2>Sign and date Form W-9</h2>
  <p>Under penalties of perjury, I certify that:</p>
  <ol>
    <li>The number shown on this form is my correct taxpayer identification number (or I am waiting for a number to be
      issued to me); and</li>
    <li>I am not subject to backup withholding because: (a) I am exempt from backup withholding, or (b) I have not been
      notified
      by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report
      all
      interest or dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding; and</li>
    <li>I am a US citizen or other US person; and</li>
    <li>The FATCA code(s) entered on this form (if any) indicating that I am exempt from FATCA reporting is correct.
    </li>
  </ol>
  <p><strong>The Internal Revenue Service does not require your consent to any provision of this document other than the
      certifications required to avoid backup withholding.</strong></p>
  <div>
    <div fxLayout="column" class="input">
      <label>Your signature</label>
      <mat-form-field class="nopadding" fxFlex>
        <input matInput [(ngModel)]="wNineName" placeholder="Enter your full legal name" />
      </mat-form-field>
      <div class="hint">By typing your full legal name above, you are electronically signing this form</div>
    </div>
    <div fxLayout="column" class="input">
      <label>Date</label>
      <mat-form-field class="nopadding" fxFlex>
        <input matInput [(ngModel)]="wNineSignedAt" disabled />
      </mat-form-field>
    </div>
  </div>
  <div fxLayoutAlign="end center" fxLayoutGap="16px">
    <sbnb-button type="secondary" label="Back" (click)="previousStep()"></sbnb-button>
    <sbnb-button type="primary" label="Submit" (click)="submit()"></sbnb-button>
  </div>
</div>
